import React from 'react';
import logo from '../images/logo.png'
import driverIcon from '../images/driver.svg'
import manIcon from '../images/man.svg'
import { useNavigate } from 'react-router-dom';

const Login = () => {

    const navigate = useNavigate()

    const handleUserRoute = name => navigate(name)

    return (
        <div className='bg-brand'>
            <div className="container">
                <div className="d-flex justify-content-center align-items-center pt-3">
                    <img className='img-fluid' src={logo} alt="vehicle" />
                    <h1 style={{ lineHeight: '50px' }} className='fw-bold mt-2'>eTracker</h1>
                </div>

                <div className="mt-5">
                    <h2 className='text-center h5 fw-bold'>Login as</h2>

                    <div className="d-flex justify-content-center align-items-center">
                        <div onClick={()=> handleUserRoute('/driver-helper')} style={{ width: '133px', height: '167px' }} className="bg-white mx-2 p-3 rounded shadow mt-3">
                            <img src={driverIcon} className='img-fluid mx-auto d-block' width={60} alt="driver icon" />
                            <h3 className="text-center h6 mt-3 fw-bold">Driver / Helper</h3>
                        </div>

                        <div onClick={() => handleUserRoute('/outlet-sto')} style={{ width: '133px', height: '167px' }} className="bg-white mx-2 p-3 rounded shadow mt-3">
                            <img src={manIcon} className='img-fluid mx-auto d-block' width={60} alt="man icon" />
                            <h3 className="text-center h6 mt-3 fw-bold">Outlet Assistant</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;